import { Spin } from '@faceup/ui-base'
import type { ReactNode } from 'react'

type FullScreenLoaderProps = {
  children?: ReactNode
}

export const FullScreenLoader = ({ children }: FullScreenLoaderProps) => {
  return (
    <div className='flex h-screen flex-col items-center justify-center'>
      <Spin size='large' />
      {children}
    </div>
  )
}
